export default __webpack_public_path__ + "static/media/Calendar.3c367437.svg";